module.exports = __webpack_public_path__ + "static/media/map1.715de3cf.PNG";